import * as Models from "../Models";
import * as Services from "../Services";
import * as Routes from "../Routes";
import * as Shared from "../Shared";

import angular = require("angular");
export interface ISetPageBackgroundColorScope extends ng.IScope {
  setPageBackgroundColorCtrl: SetPageBackgroundDirective;
}

export class SetPageBackgroundDirective implements ng.IDirective {
  public restrict = "A";

  public scope = {};

  public link = (
    $rootScope: ng.IRootScopeService,
    $elem: ng.IAugmentedJQuery
  ) => {
    $rootScope.$on(
      "$stateChangeStart",
      (event: angular.IAngularEvent, toState: angular.ui.IState) => {
        if (
          toState.name === "main.customercreditcheck" ||
          toState.name === "main.costCalculationSandbox" ||
          toState.name === "main.costCalculationAssociate" ||
          toState.name === "main.reconcileSystemData" ||
          toState.name === "main.amendRateEscalator" ||
          toState.name === "main.residentialPaymentCapture" ||
          toState.name === "main.updatePaymentMethod" ||
          toState.name === "main.updatePaymentMethodCustomer" ||
          toState.name === "main.customersearch" ||
          toState.name === "main.customer" ||
          toState.name === "main.customercreate" ||
          toState.name === "main.communityPaymentCapture" ||
          toState.name === "main.customeredit" ||
          toState.name === "main.residentialPaymentCaptureConfirmation" ||
          toState.name === "main.commercialCustomerCapture" ||
          toState.name === "docusignRedirect" ||
          toState.name === "signedRemoteLanding" ||
          toState.name === "cancelRemoteLanding" ||
          toState.name === "main.submitScheduleA1" ||
          toState.name === "main.approveScheduleA1" ||
          toState.name === "main.contractOptions" ||
          toState.name === "main.submitDesignModification" ||
          toState.name === "cancelRemoteLanding" ||
          toState.name === "main.allIssues" ||
          toState.name === "main.upsertIssue" ||
          toState.name === "main.issueCreate" ||
          toState.name === "main.submitSystemDetails" ||
          toState.name === "main.manageSystemDetails" ||
          toState.name === "main.submitMilestone" ||
          toState.name === "main.amendnameaddress" ||
          toState.name === "main.pricingOverride" ||
          toState.name === "main.contractTransfer" ||
          toState.name === "main.submitAdditionalInvoice") {
          $elem.attr("style", "background-color: #E0F3FB");
        } else {
          $elem.attr("style", "background-color: white");
        }
      }
    );
  };
}

var app = angular.module("set.Page.Background.Color", []);
app.directive(
  "setPageBackgroundColor",
  Shared.Framework.DirectiveHelpers.create(SetPageBackgroundDirective)
);
